<template>
  <div>
    <!-- <div class="seth-set bg-primary">
      
      <div class="absolute bottom-0 mb-4 px-8"></div>
    </div> -->
    <div class="w-full bg-white px-8 py-12 flex justify-center items-center">
      <div class="text-center">
        <img
          class=""
          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/failure.png"
          alt="bill"
        />

        <h2 class="text-2xl font-bold text-black mt-2">Your Payment Failed</h2>
        <p class="text-lg font-semibold text-gray mt-4">
          Thank you for payment. An automated payment receipt will be send to
          your registered email.
        </p>
        <p
          class="text-lg font-semibold text-primary cursor-pointer underline mt-2"
          @click="handleClick('settings-Payment')"
        >
          Back to Home
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<
